import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Role } from "./role.types"
import { SESSION_EDIT, SESSION_GET } from "./_session.types"

export interface RolesState {
  accountId: string | null
  list: Role[]
  status: "idle" | "loading" | "loaded" | "error"
  requestId: string | null
}

const initialState: RolesState = { accountId: null, list: [], status: "idle", requestId: null }
const slice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    loading: (_state, action: PayloadAction<{ accountId: string; requestId: string }>) => ({
      ...initialState, ...action.payload, status: "loading"
    }),
    loaded: (state, action: PayloadAction<{ accountId: string; requestId: string; list: Role[] }>) => {
      if (state.accountId !== action.payload.accountId || state.requestId !== action.payload.requestId) return
      state.list = action.payload.list
      state.status = "loaded"
    },
    failed: (state, action: PayloadAction<{ requestId: string }>) => {
      if (state.requestId === action.payload.requestId) state.status = "error"
    },
    saved: (state, action: PayloadAction<{ accountId: string; requestId: string | null; role: Role }>) => {
      if (state.accountId !== action.payload.accountId || state.requestId !== action.payload.requestId) return
      const index = state.list.findIndex((role) => role.id === action.payload.role.id)
      if (index === -1) state.list.push(action.payload.role)
      else state.list[index] = action.payload.role
    },
    removed: (state, action: PayloadAction<{ accountId: string; requestId: string | null; id: string }>) => {
      if (state.accountId !== action.payload.accountId || state.requestId !== action.payload.requestId) return
      state.list = state.list.filter((role) => role.id !== action.payload.id)
    },
    reset: () => initialState
  }
})

export const roleActions = slice.actions
export default function rolesReducer(state: RolesState | undefined, action: any): RolesState {
  if (action.type === SESSION_GET || (action.type === SESSION_EDIT && action.payload.key === "accountId")) {
    return initialState
  }
  return slice.reducer(state, action)
}
